var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-balances","hide-footer":"","hide-header":"","size":"sm","ok-only":""}},[_c('h3',{staticClass:"modal-title"},[_vm._v(" Balances ")]),_c('div',{staticClass:"modal-body p-0"},[_c('BalancesDetailInvestors',{attrs:{"showTitle":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }